/* Subscribe Radio – Shop name theme
   Rich design with VIP badge, benefits, frequency inside card.
   Integrates with bundle-pack-addon.js and simple bundle-picker. */
(function () {
  function init(container) {
    if (!container) return;

    var productId = container.dataset.productId;
    var discountPercentage = Number(container.dataset.discountPercentage || 0);
    var sellingPlanIdA = container.dataset.sellingPlanIdA || '';
    var sellingPlanIdB = container.dataset.sellingPlanIdB || '';
    var defaultSubscription = container.dataset.defaultSubscription === 'true';
    var subscriptionAvailable = container.dataset.initialDisabled !== 'true';
    var locale = container.dataset.locale || 'fr-FR';
    var currency = container.dataset.currency || 'EUR';
    var defaultFrequency = container.dataset.defaultFrequency || '';
    var frequencyMode = container.dataset.frequencyMode || 'segmented';
    var syncedFrequencyPrefix = container.dataset.syncedFrequencyPrefix || 'Livraison {label}';
    var freqALabel = container.dataset.freqALabel || '';
    var freqAValue = container.dataset.freqAValue || '';
    var freqBLabel = container.dataset.freqBLabel || '';
    var freqBValue = container.dataset.freqBValue || '';
    var radios = container.querySelectorAll('input[type="radio"][name="purchase_option_' + productId + '"]');
    var subscribeCard = container.querySelector('.subscribe-radio__card--subscribe');
    var onetimeCard = container.querySelector('.subscribe-radio__card--onetime');
    var frequencyWrap = container.querySelector('.subscribe-radio__frequency');
    var frequencySyncedWrap = container.querySelector('.subscribe-radio__frequency-synced');
    var frequencySyncedText = container.querySelector('[data-frequency-synced-text]');
    var frequencyOptions = container.querySelectorAll('.subscribe-radio__frequency-option');
    var perksWrap = container.querySelector('.subscribe-radio__perks');
    var vipBadge = container.querySelector('.subscribe-radio__vip-badge');
    var selectedFrequency = defaultFrequency;
    var variantsScript = container.querySelector('.subscribe-radio-variants');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript && variantsScript.textContent || '[]');
    } catch (_) {}

    /* ── bundle price state ── */
    var bundlePrice = null;
    var bundlePriceBeforeDiscount = null;

    /* ── helpers ── */

    function getActiveSellingPlanId() {
      if (!subscriptionAvailable) return '';
      var freq = selectedFrequency || defaultFrequency;
      if (freq && freqBValue && String(freq) === String(freqBValue)) return sellingPlanIdB;
      return sellingPlanIdA;
    }

    function getCurrentVariant() {
      var section = container.closest('.shopify-section, [id^="MainProduct"], product-info');
      var variantInput = section
        ? section.querySelector('input[name="id"]')
        : document.querySelector('input[name="id"]');
      var id = variantInput ? variantInput.value : null;
      return variants.find(function (v) { return String(v.id) === String(id); });
    }

    function formatMoney(amount) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount / 100).replace(/\s/g, '');
      } catch (_) {
        return (amount / 100).toFixed(2);
      }
    }

    function parsePriceString(str) {
      if (!str) return null;
      var cleaned = str.replace(/[^\d.,]/g, '').trim();
      if (!cleaned) return null;
      var lastComma = cleaned.lastIndexOf(',');
      var lastDot = cleaned.lastIndexOf('.');
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else if (lastDot > lastComma) {
        cleaned = cleaned.replace(/,/g, '');
      }
      var value = parseFloat(cleaned);
      if (isNaN(value)) return null;
      return Math.round(value * 100);
    }

    function getEffectivePrice() {
      var variant = getCurrentVariant();
      if (bundlePrice !== null && bundlePrice > 0) {
        return {
          price: bundlePrice,
          compareAtPrice: bundlePriceBeforeDiscount && bundlePriceBeforeDiscount > bundlePrice
            ? bundlePriceBeforeDiscount : null,
          source: 'bundle'
        };
      }
      if (!variant) return null;
      return {
        price: variant.price,
        compareAtPrice: variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price : null,
        source: 'variant'
      };
    }

    /* ── visual state: active card, show/hide frequency & benefits ── */

    function applyVisualState(selected) {
      var isSub = selected === 'subscribe';

      if (subscribeCard) {
        if (isSub) subscribeCard.classList.add('is-active');
        else subscribeCard.classList.remove('is-active');
      }
      if (onetimeCard) {
        if (!isSub) onetimeCard.classList.add('is-active');
        else onetimeCard.classList.remove('is-active');
      }
      if (frequencyWrap) frequencyWrap.style.display = isSub ? 'flex' : 'none';
      if (frequencySyncedWrap) frequencySyncedWrap.style.display = isSub ? 'flex' : 'none';
      if (perksWrap) perksWrap.style.display = isSub ? 'flex' : 'none';
      if (vipBadge) vipBadge.style.display = isSub ? 'inline-flex' : 'none';
    }

    /* ── price updates on the radio cards ── */

    function updatePrices(isSubscription) {
      var effective = getEffectivePrice();
      if (!effective) return;

      // Subscription card prices
      var subOriginal = container.querySelector('.subscribe-radio__sub-original');
      var subFinal = container.querySelector('.subscribe-radio__sub-final');
      if (subOriginal && subFinal) {
        var discount = Math.round(effective.price * discountPercentage / 100);
        var finalPrice = effective.price - discount;
        subOriginal.textContent = formatMoney(effective.compareAtPrice || effective.price);
        subFinal.textContent = formatMoney(finalPrice);
        subOriginal.style.display = 'inline';
      }

      // One-time card prices
      var otOriginal = container.querySelector('.subscribe-radio__onetime-original');
      var otFinal = container.querySelector('.subscribe-radio__onetime-final');
      if (otOriginal && otFinal) {
        if (effective.compareAtPrice) {
          otOriginal.textContent = formatMoney(effective.compareAtPrice);
          otOriginal.style.display = 'inline';
          otFinal.textContent = formatMoney(effective.price);
        } else {
          otOriginal.style.display = 'none';
          otFinal.textContent = formatMoney(effective.price);
        }
      }
    }

    /* ── submit-button price update ── */

    function updateButtonPrice(isSubscription) {
      var effective = getEffectivePrice();
      if (!effective) return;

      var priceDisplay = document.querySelector('[data-price-display]');
      var submitButton = document.querySelector('.product-form__submit');
      if (!priceDisplay) return;

      /* Coordination prix bouton : quand l'abonnement est actif, c'est subscribe-radio qui
         fait autorité. On lève un drapeau pour que variant-picker.liquid ne réécrive pas
         par-dessus (sinon le prix oscille achat-unique <-> abo au chargement = flash). */
      window.__subPriceActive = !!isSubscription;

      /* Micro-fondu : on atténue le prix le temps de l'écriture, puis on le révèle au frame
         suivant — le changement de valeur est perçu comme un fondu doux, pas un saut sec. */
      priceDisplay.classList.add('is-price-updating');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { priceDisplay.classList.remove('is-price-updating'); });
      });

      /* Remove any sibling compare-price <s> (created by quantity-picker) to avoid duplicates */
      var siblingCompare = priceDisplay.parentNode && priceDisplay.parentNode.querySelector('.product-form__submit-compare-price');
      if (siblingCompare) siblingCompare.remove();

      if (isSubscription) {
        var discount = Math.round(effective.price * discountPercentage / 100);
        var finalPrice = effective.price - discount;
        var beforePrice = effective.compareAtPrice || effective.price;
        priceDisplay.innerHTML =
          '<span class="price-discounted">' + formatMoney(finalPrice) + '</span>' +
          '<span class="price-before-discount">' + formatMoney(beforePrice) + '</span>';
        if (submitButton) submitButton.dataset.productPrice = String(finalPrice);
      } else {
        if (effective.compareAtPrice) {
          priceDisplay.innerHTML =
            '<span class="price-discounted">' + formatMoney(effective.price) + '</span>' +
            '<span class="price-before-discount">' + formatMoney(effective.compareAtPrice) + '</span>';
        } else {
          priceDisplay.textContent = formatMoney(effective.price);
        }
        if (submitButton) submitButton.dataset.productPrice = String(effective.price);
      }
    }

    /* ── product form manipulation ── */

    function findProductForm() {
      /* Scope: the same shopify-section as our subscribe-radio container.
         Prefer the form inside <product-form>, which is the real ATC form.
         Exclude installment forms and upsell-drawer forms. */
      var section = container.closest('[id^="shopify-section"]') || document;
      var candidates = section.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < candidates.length; i++) {
        var f = candidates[i];
        if (f.closest('product-form')) return f;
      }
      /* Fallback: first form in the section that isn't installment/upsell */
      for (var j = 0; j < candidates.length; j++) {
        var f2 = candidates[j];
        if (f2.id && f2.id.indexOf('installment') !== -1) continue;
        if (f2.classList.contains('upsell-drawer-form')) continue;
        return f2;
      }
      return null;
    }

    function updateProductForm(selected) {
      var form = findProductForm();
      if (!form) return;

      /* selling_plan — remove ALL existing inputs (Seal may inject its own) */
      var allPlanInputs = form.querySelectorAll('input[name="selling_plan"]');
      allPlanInputs.forEach(function (el) { el.remove(); });

      var activePlanId = getActiveSellingPlanId();
      if (selected === 'subscribe' && activePlanId) {
        var planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        planInput.value = activePlanId;
        form.appendChild(planInput);
      }

      /* frequency as line-item property */
      var existingFreq = form.querySelector('input[name="properties[_frequency]"]');
      if (existingFreq) existingFreq.remove();

      if (selected === 'subscribe') {
        var freqInput = document.createElement('input');
        freqInput.type = 'hidden';
        freqInput.name = 'properties[_frequency]';
        freqInput.value = selectedFrequency || defaultFrequency;
        form.appendChild(freqInput);
      }

      /* custom event for other scripts */
      form.dispatchEvent(new CustomEvent('purchase-option:change', {
        detail: {
          option: selected,
          sellingPlanId: activePlanId,
          frequency: selectedFrequency
        }
      }));
    }

    /* ── refresh ── */

    function refresh() {
      var checked = container.querySelector('input[type="radio"]:checked');
      var selected = checked ? checked.value : 'one_time';
      updatePrices(selected === 'subscribe');
      updateButtonPrice(selected === 'subscribe');
    }

    /* ── bundle-pack-addon.js integration ── */

    document.addEventListener('bundlePackPrice:change', function (e) {
      var detail = e.detail;
      if (!detail) return;
      if (detail.hasSelections && detail.totalPrice > 0) {
        bundlePrice = detail.totalPrice;
        bundlePriceBeforeDiscount = detail.totalPriceBeforeDiscount || null;
      } else {
        bundlePrice = null;
        bundlePriceBeforeDiscount = null;
      }
      refresh();
    });

    /* ── simple bundle-picker integration ──
       Skip when bundle-pack is present — prices come from bundlePackPrice:change */

    if (!document.querySelector('[data-bundle-pack]')) {
      document.addEventListener('click', function (e) {
        var option = e.target.closest('.bundle-picker__option');
        if (!option) return;
        setTimeout(function () {
          var activeOption = document.querySelector('.bundle-picker__option.is-active');
          if (!activeOption) return;
          var parsed = parsePriceString(activeOption.dataset.price || activeOption.dataset.atcPrice);
          var parsedCompare = parsePriceString(activeOption.dataset.comparePrice || activeOption.dataset.atcComparePrice);
          if (parsed !== null && parsed > 0) {
            bundlePrice = parsed;
            bundlePriceBeforeDiscount = (parsedCompare && parsedCompare > parsed) ? parsedCompare : null;
          } else {
            bundlePrice = null;
            bundlePriceBeforeDiscount = null;
          }
          refresh();
        }, 50);
      });
    }

    /* ── radio change listeners ── */

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var selected = this.value;
        applyVisualState(selected);
        updateProductForm(selected);
        updatePrices(selected === 'subscribe');
        updateButtonPrice(selected === 'subscribe');
        /* Sync with Seal: send selling_plan_id or empty string for one-time */
        syncWithSeal(selected === 'subscribe' ? getActiveSellingPlanId() : '');
      });
    });

    /* ── clickable cards (click anywhere on card toggles radio) ── */

    if (subscribeCard) {
      subscribeCard.addEventListener('click', function (e) {
        if (e.target.type === 'radio' || e.target.closest('.subscribe-radio__frequency-option')) return;
        var radio = subscribeCard.querySelector('input[type="radio"]');
        if (radio && !radio.checked && !radio.disabled) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (onetimeCard) {
      onetimeCard.addEventListener('click', function (e) {
        if (e.target.type === 'radio') return;
        var radio = onetimeCard.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* ── frequency change (segmented buttons) ── */

    function selectFrequencyOption(btn, focus) {
      selectedFrequency = btn.dataset.frequencyValue || selectedFrequency;
      frequencyOptions.forEach(function (b) {
        var isActive = b === btn;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-checked', isActive ? 'true' : 'false');
        b.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      if (focus) btn.focus();
      var checked = container.querySelector('input[type="radio"]:checked');
      updateProductForm(checked ? checked.value : 'one_time');
    }

    /* roving tabindex: only the active option is tab-reachable (fallback: first) */
    var hasActiveFreq = Array.prototype.some.call(frequencyOptions, function (b) {
      return b.classList.contains('is-active');
    });
    frequencyOptions.forEach(function (b, i) {
      var tabbable = b.classList.contains('is-active') || (!hasActiveFreq && i === 0);
      b.setAttribute('tabindex', tabbable ? '0' : '-1');
    });

    frequencyOptions.forEach(function (btn, idx) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectFrequencyOption(btn, false);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowDown' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
        var next = (idx + dir + frequencyOptions.length) % frequencyOptions.length;
        selectFrequencyOption(frequencyOptions[next], true);
      });
    });

    /* ── frequency sync with quantity-picker ──
       The picker emits data-frequency-value: "none" | "30" | "60" (days).
       When "none", subscription is not available for this variant: hide the
       block and force one-time purchase. */

    /* Parent immediate is the Liquid wrapper {{ block.shopify_attributes }}.
       The "Fréquence d'achat" text block is its previousElementSibling
       when both blocks are placed next to each other in the section. */
    var blockWrapper = container.parentElement;
    var previousBlock = blockWrapper && blockWrapper.previousElementSibling;

    function setSubscriptionVisible(visible) {
      if (blockWrapper) blockWrapper.style.display = visible ? '' : 'none';
      if (previousBlock) previousBlock.style.display = visible ? '' : 'none';
      /* The container itself may have inline display:none from Liquid (anti-flash). */
      container.style.display = visible ? '' : 'none';
    }

    function readFrequencyFromOption(option) {
      if (!option) return null;
      var v = option.dataset.frequencyValue;
      /* Back-compat: legacy a/b */
      if (v === 'a') return freqAValue || '30';
      if (v === 'b') return freqBValue || '60';
      return v || null;
    }

    function applySyncedFrequencyFromOption(option) {
      if (!option) return;
      var freq = readFrequencyFromOption(option);
      if (freq === 'none' || freq == null) {
        subscriptionAvailable = false;
        setSubscriptionVisible(false);
        var onetimeRadio = container.querySelector('input[type="radio"][value="one_time"]');
        if (onetimeRadio && !onetimeRadio.checked) {
          onetimeRadio.checked = true;
          applyVisualState('one_time');
        }
        updateProductForm('one_time');
        /* No subscription frequency available: display the one-time price,
           never the subscription-discounted price. */
        updatePrices(false);
        updateButtonPrice(false);
        return;
      }
      var wasUnavailable = !subscriptionAvailable;
      subscriptionAvailable = true;
      setSubscriptionVisible(true);
      selectedFrequency = freq;
      var label = freq + ' jours';
      if (frequencySyncedText) {
        frequencySyncedText.textContent = syncedFrequencyPrefix.replace('{label}', label);
      }
      /* Coming back from "none": restore the merchant-configured default
         (subscription pre-selected if defaultSubscription is true). */
      if (wasUnavailable && defaultSubscription) {
        var subscribeRadio = container.querySelector('input[type="radio"][value="subscribe"]');
        if (subscribeRadio && !subscribeRadio.checked) {
          subscribeRadio.checked = true;
          applyVisualState('subscribe');
          updateProductForm('subscribe');
          updatePrices(true);
          updateButtonPrice(true);
        }
      }
    }

    if (frequencyMode === 'synced_with_quantity') {
      document.addEventListener('click', function (e) {
        var option = e.target.closest('.bundle-picker__option');
        if (!option) return;
        setTimeout(function () {
          var activeOption = document.querySelector('.bundle-picker__option.is-active');
          if (!activeOption) return;
          applySyncedFrequencyFromOption(activeOption);
          var checked = container.querySelector('input[type="radio"]:checked');
          updateProductForm(checked ? checked.value : 'one_time');
        }, 50);
      });

      /* init from the currently-active bundle-picker option */
      var initSyncedOption = document.querySelector('.bundle-picker__option.is-active');
      if (initSyncedOption) applySyncedFrequencyFromOption(initSyncedOption);
    }

    /* ── Seal Subscriptions integration ── */

    /* Hide the native Seal widget if it appears after our block */
    document.addEventListener('sealsubs:subscription_widget_created', function () {
      var sealWidgets = document.querySelectorAll('.sealsubs-target-element, .seal-subscription-widget, [data-seal-extension]');
      sealWidgets.forEach(function (w) { w.style.display = 'none'; });
    });

    /* Prevent Seal from re-injecting selling_plan inputs we don't want */
    (function () {
      var form = findProductForm();
      if (!form) return;
      var observer = new MutationObserver(function () {
        var checked = container.querySelector('input[type="radio"]:checked');
        var isSubscribe = checked && checked.value === 'subscribe';
        var planInputs = form.querySelectorAll('input[name="selling_plan"]');

        if (!isSubscribe) {
          /* One-time mode: remove ALL selling_plan inputs (Seal may inject empty ones) */
          planInputs.forEach(function (el) { el.remove(); });
        } else if (planInputs.length > 1) {
          /* Subscribe mode: keep only the last one (ours), remove Seal duplicates */
          for (var i = 0; i < planInputs.length - 1; i++) {
            planInputs[i].remove();
          }
        }
      });
      observer.observe(form, { childList: true, subtree: true });
    })();

    /* Sync our selection with Seal's internal state */
    function syncWithSeal(planId) {
      var sealWidget = document.querySelector('.sealsubs-target-element');
      if (sealWidget) {
        sealWidget.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
          detail: { selling_plan_id: planId || '' }
        }));
      }
    }

    /* Listen for Seal price updates — ignore them entirely.
       We handle all subscription price display ourselves via
       getEffectivePrice() + discountPercentage. Seal's price_update
       was overwriting our calculated prices (especially the abo discount). */

    /* Seal may emit selling_plan_changed but we are the source of truth
       for which plan to send (A or B based on frequency). Re-assert our
       active plan instead of accepting Seal's value. */
    document.addEventListener('sealsubs:selling_plan_changed', function () {
      var checked = container.querySelector('input[type="radio"]:checked');
      if (checked && checked.value === 'subscribe') {
        updateProductForm('subscribe');
      }
    });

    /* ── guard: force correct selling_plan just before submit ── */
    /* Seal can overwrite our selling_plan input with an empty value after
       init. By listening in the capture phase we run BEFORE product-form.js
       reads the FormData, so the correct value is always submitted. */
    (function () {
      var form = findProductForm();
      if (!form) return;
      form.addEventListener('submit', function () {
        var checked = container.querySelector('input[type="radio"]:checked');
        var isSubscribe = checked && checked.value === 'subscribe';

        /* Remove all existing selling_plan inputs */
        var inputs = form.querySelectorAll('input[name="selling_plan"]');
        inputs.forEach(function (el) { el.remove(); });

        var activePlanId = getActiveSellingPlanId();
        if (isSubscribe && activePlanId) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'selling_plan';
          inp.value = activePlanId;
          form.appendChild(inp);
        }
      }, true); /* capture phase = runs before product-form.js handler */
    })();

    /* ── initial state ── */

    /* Pick up the quantity-picker's active option price at init
       Skip when bundle-pack is present — it manages prices via bundlePackPrice:change event */
    if (!document.querySelector('[data-bundle-pack]')) {
      var initActiveOption = document.querySelector('.bundle-picker__option.is-active');
      if (initActiveOption) {
        var initParsed = parsePriceString(initActiveOption.dataset.price || initActiveOption.dataset.atcPrice);
        var initParsedCompare = parsePriceString(initActiveOption.dataset.comparePrice || initActiveOption.dataset.atcComparePrice);
        if (initParsed !== null && initParsed > 0) {
          bundlePrice = initParsed;
          bundlePriceBeforeDiscount = (initParsedCompare && initParsedCompare > initParsed) ? initParsedCompare : null;
        }
      }
    }

    /* If subscription is not available for the initial variant, force one-time
       and hide the block (Liquid already set display:none on the container to
       avoid flash; we mirror it on the wrapper + previous text block). */
    var initiallySelected = (defaultSubscription && subscriptionAvailable) ? 'subscribe' : 'one_time';
    if (!subscriptionAvailable) setSubscriptionVisible(false);
    applyVisualState(initiallySelected);
    updateProductForm(initiallySelected);
    updatePrices(initiallySelected === 'subscribe');
    updateButtonPrice(initiallySelected === 'subscribe');

    /* Sync initial state with Seal */
    if (initiallySelected === 'subscribe') {
      var initialPlanId = getActiveSellingPlanId();
      if (initialPlanId) syncWithSeal(initialPlanId);
    }

    /*
     * Force re-application après le load : le variant-picker (et d'autres scripts
     * inline) peuvent écrire dans .product-form__submit-price "before first paint",
     * écrasant ce qu'on vient de poser. On rejoue donc updateButtonPrice après
     * que tout le DOM soit prêt, pour reprendre la main.
     */
    function reapplyAfterLoad() {
      var checked = container.querySelector('input[type="radio"]:checked');
      var selected = checked ? checked.value : initiallySelected;
      updateButtonPrice(selected === 'subscribe');
    }
    if (document.readyState === 'complete') {
      setTimeout(reapplyAfterLoad, 0);
    } else {
      window.addEventListener('load', function () { setTimeout(reapplyAfterLoad, 0); });
    }

    /* ── variant change hooks (FLOWEE pubsub) ── */

    function hasBundlePackActive() {
      var bp = document.querySelector('[data-bundle-pack]');
      return bp && bp.bundlePackAddon && bp.bundlePackAddon.selectedVariants && bp.bundlePackAddon.selectedVariants.size > 0;
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (!hasBundlePackActive()) {
          bundlePrice = null;
          bundlePriceBeforeDiscount = null;
        }
        refresh();
        var checked = container.querySelector('input[type="radio"]:checked');
        updateProductForm(checked ? checked.value : 'one_time');
      });
    }

    /* fallback DOM event */
    document.addEventListener('variant:change', function () {
      if (!hasBundlePackActive()) {
        bundlePrice = null;
        bundlePriceBeforeDiscount = null;
      }
      refresh();
    });
  }

  /* Run immediately – script tag is placed after the HTML */
  function run() {
    document.querySelectorAll('.subscribe-radio').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
